import type React from "react";
import { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Avatar,
  Badge,
  InputBase,
  useTheme,
  alpha,
  Collapse,
  useMediaQuery,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";
import {
  Search,
  Notifications,
  ExpandMore,
  ExpandLess,
  Language,
  Menu as MenuIcon,
  VpnKey,
  Add,
  List as ListIcon,
  Person,
  Settings,
  Logout,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthTypes from "../../../redux/constants";
import { useAdminPermission } from "../../../hooks/useAdminPermission";
import UnauthorizedAccess from "../../../components/UnauthorizedAccess";
import ProtectedAdminPage from "../../../components/ProtectedAdminPage";

// Import components
// import FileManagerPage from "./pages/file-manager"
// import AnalyticsPage from "./pages/analytics"
// import BankingPage from "./pages/banking"
// import EcommercePage from "./pages/ecommerce"
// import AppPage from "./pages/app"
// import BookingPage from "./pages/booking"
// import CoursePage from "./pages/course"
// import UserProfilePage from "./pages/user-profile"
// import UserCardsPage from "./pages/user-cards"
// import UserListPage from "./pages/user-list"
// import UserCreatePage from "./pages/user-create"
// import UserEditPage from "./pages/user-edit"
// import UserAccountPage from "./pages/user-account"
import SerialManagementPage from "../Pages/SerialManagementPage";
import SerialGenerationPage from "../Pages/SerialGenerationPage";
import BatchListPage from "../Pages/BatchListPage";
import DistributorCreatePage from "../Pages/Distributor"
import DistributorConstancePage from "../Pages/DistributorConstance"
import CertificatesListPage from "../Pages/CertificatesList"
import UserImporterPage from "../Pages/UserImporterPage"
import UserEditPage from "../Pages/UserEditPage"
import SearchUserCoursesPage from "../Pages/SearchUserCoursesPage"

const drawerWidth = 280;

interface DashboardMenuItem {
  text: string;
  icon: React.ReactNode;
  key: string;
  submenu?: { text: string; key: string }[];
}

// Mejor práctica: Mapeo de componentes
const PAGE_COMPONENTS: Record<string, React.ComponentType> = {
  // app: AppPage,
  // ecommerce: EcommercePage,
  // analytics: AnalyticsPage,
  // banking: BankingPage,
  // booking: BookingPage,
  // "file-manager": FileManagerPage,
  // course: CoursePage,
  // "user-profile": UserProfilePage,
  // "user-cards": UserCardsPage,
  // "user-list": UserListPage,
  // "user-create": UserCreatePage,
  // "user-edit": UserEditPage,
  // "user-account": UserAccountPage,
  "distributor-generation": DistributorCreatePage,
  "distributor-constance": DistributorConstancePage,
  "serial-generation": SerialGenerationPage,
  "batch-list": BatchListPage,
  "certificates-list": CertificatesListPage,
  "serial-management": SerialManagementPage,
  "user-importer": UserImporterPage,
  "user-edit": UserEditPage,
  "search-user-courses": SearchUserCoursesPage,
};

// Componente para páginas que aún no están implementadas
const ComingSoonPage = ({ title }: { title: string }) => (
  <Box sx={{ p: 3, textAlign: "center" }}>
    <Typography variant="h5" gutterBottom>
      {title}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {title} page coming soon
    </Typography>
  </Box>
);

const sidebarItems = [
  // {
  //   category: "OVERVIEW",
  //   items: [
  //     { text: "App", icon: <Apps />, key: "app", submenu: undefined },
  //     { text: "Ecommerce", icon: <ShoppingBag />, key: "ecommerce", submenu: undefined },
  //     { text: "Analytics", icon: <Analytics />, key: "analytics", submenu: undefined },
  //     { text: "Banking", icon: <AccountBalance />, key: "banking", submenu: undefined },
  //     { text: "Booking", icon: <EventNote />, key: "booking", submenu: undefined },
  //     { text: "File", icon: <Folder />, key: "file-manager", submenu: undefined },
  //     { text: "Course", icon: <School />, key: "course", submenu: undefined },
  //   ] as DashboardMenuItem[],
  // },
  {
    category: "MANAGEMENT",
    items: [
      // {
      //   text: "User",
      //   icon: <Person />,
      //   key: "user",
      //   submenu: [
      //     { text: "Profile", key: "user-profile" },
      //     { text: "Cards", key: "user-cards" },
      //     { text: "List", key: "user-list" },
      //     { text: "Create", key: "user-create" },
      //     { text: "Edit", key: "user-edit" },
      //     { text: "Account", key: "user-account" },
      //   ],
      // },
      // { text: "Product", icon: <Inventory />, key: "product", submenu: undefined },
      // { text: "Order", icon: <ShoppingCart />, key: "order", submenu: undefined },
      // { text: "Invoice", icon: <Receipt />, key: "invoice", submenu: undefined },
      // { text: "Blog", icon: <Article />, key: "blog", submenu: undefined },
      // { text: "Job", icon: <Work />, key: "job", submenu: undefined },
      // { text: "Tour", icon: <Tour />, key: "tour", submenu: undefined },
      
      {
        text: "Crear empresa/distribuidor",
        icon: <Add />,
        key: "distributor-generation",
        submenu: undefined,
      },
      {
        text: "Agregar constancias por empresa/distribuidor",
        icon: <Add />,
        key: "distributor-constance",
        submenu: undefined,
      },
      {
        text: "Generar Lotes",
        icon: <Add />,
        key: "serial-generation",
        submenu: undefined,
      },
      {
        text: "Lista de Lotes",
        icon: <ListIcon />,
        key: "batch-list",
        submenu: undefined,
      },
      {
        text: "Lista de constancias por empresa/distribuidor y curso",
        icon: <ListIcon />,
        key: "certificates-list",
        submenu: undefined,
      },
      {
        text: "Seriales",
        icon: <VpnKey />,
        key: "serial-management",
        submenu: undefined,
      },
      {
        text: "Importar usuarios",
        icon: <ListIcon />,
        key: "user-importer",
        submenu: undefined,
      },
      {
        text: "Editar usuario",
        icon: <Person />,
        key: "user-edit",
        submenu: undefined,
      },
      {
        text: "Buscar Cursos de Usuarios",
        icon: <ListIcon />,
        key: "search-user-courses",
        submenu: undefined,
      },
    ] as DashboardMenuItem[],
  },
];

export default function DashboardAdmin() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state: any) => state.auth);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [activeItem, setActiveItem] = useState<string | null>(null);
  const [expandedItems, setExpandedItems] = useState<string[]>([]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openUserMenu = Boolean(anchorEl);

  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    console.log("Cerrando sesión...");
    handleUserMenuClose();
    closeSession();
    // Aquí iría la lógica de logout
  };

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setDesktopOpen(!desktopOpen);
    }
  };

  const handleItemClick = (key: string) => {
    setActiveItem(key);

    // Auto-expand parent menu if clicking on a submenu item
    if (key.includes("-")) {
      const parentKey = key.split("-")[0];
      if (!expandedItems.includes(parentKey)) {
        setExpandedItems((prev) => [...prev, parentKey]);
      }
    }

    // Close mobile drawer when item is clicked
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const handleExpandClick = (key: string) => {
    setExpandedItems((prev) =>
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key]
    );
  };

  const isItemActive = (key: string) => {
    if (!activeItem) return false;
    if (activeItem === key) return true;
    if (activeItem.startsWith(key + "-")) return true;
    return false;
  };

  const { hasAccess, canWrite } = useAdminPermission();

  // Cargar el primer módulo accesible cuando el usuario inicia sesión
  useEffect(() => {
    if (!activeItem && authState?.user?.rol?.clave) {
      // Buscar el primer item accesible en sidebarItems
      for (const section of sidebarItems) {
        for (const item of section.items) {
          if (hasAccess(item.key)) {
            setActiveItem(item.key);
            return;
          }
        }
      }
    }
  }, [authState?.user?.rol?.clave, hasAccess, activeItem]);

  // Mejor práctica: Renderizado dinámico de componentes
  const renderContent = () => {
    if (!activeItem) {
      return (
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="h6" color="textSecondary">
            Cargando...
          </Typography>
        </Box>
      );
    }

    const Component = PAGE_COMPONENTS[activeItem];

    if (Component) {
      return (
        <ProtectedAdminPage moduleKey={activeItem}>
          <Component />
        </ProtectedAdminPage>
      );
    }

    // Para páginas que no están implementadas, mostrar "Coming Soon"
    const pageTitle =
      activeItem.charAt(0).toUpperCase() +
      activeItem.slice(1).replace("-", " ");
    return <ComingSoonPage title={pageTitle} />;
  };

  const closeSession = () => {
    dispatch({
      type: AuthTypes.LOGOUT,
    });
    navigate("/login-admin");
  };

  const drawer = (
    <Box sx={{ height: "100%", backgroundColor: "#FAFAFA" }}>
      <Box sx={{ p: 2.5, display: "flex", alignItems: "center", gap: 2 }}>
        <Box
          sx={{
            width: 28,
            height: 28,
            backgroundColor: "#10B981",
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="body1" color="white" fontWeight="bold">
            A
          </Typography>
        </Box>
        <Typography
          variant="h6"
          fontWeight="bold"
          color="#374151"
          sx={{ fontSize: "1.1rem" }}
        >
          Administrador
        </Typography>
      </Box>

      <Box sx={{ px: 1.5 }}>
        {sidebarItems.map((section) => (
          <Box key={section.category} sx={{ mb: 2.5 }}>
            <Typography
              variant="caption"
              sx={{
                color: "#9CA3AF",
                fontWeight: 600,
                letterSpacing: "0.5px",
                px: 2,
                mb: 1,
                display: "block",
                fontSize: "0.7rem",
              }}
            >
              {section.category}
            </Typography>
            <List sx={{ p: 0 }}>
              {section.items
                .filter((item) => hasAccess(item.key))
                .map((item) => (
                <Box key={item.key}>
                  <ListItem disablePadding sx={{ mb: 0.5 }}>
                    <ListItemButton
                      onClick={() => {
                        if (item.submenu) {
                          handleExpandClick(item.key);
                        } else {
                          handleItemClick(item.key);
                        }
                      }}
                      sx={{
                        borderRadius: 2,
                        mx: 1,
                        py: 1,
                        backgroundColor: isItemActive(item.key)
                          ? "#10B981"
                          : "transparent",
                        color: isItemActive(item.key) ? "white" : "#6B7280",
                        "&:hover": {
                          backgroundColor: isItemActive(item.key)
                            ? "#059669"
                            : alpha("#10B981", 0.1),
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          color: "inherit",
                          minWidth: 32,
                          "& .MuiSvgIcon-root": { fontSize: 18 },
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.text}
                        primaryTypographyProps={{
                          fontSize: "0.8rem",
                          fontWeight: isItemActive(item.key) ? 600 : 500,
                        }}
                      />
                      {item.submenu &&
                        (expandedItems.includes(item.key) ? (
                          <ExpandLess sx={{ fontSize: 18 }} />
                        ) : (
                          <ExpandMore sx={{ fontSize: 18 }} />
                        ))}
                    </ListItemButton>
                  </ListItem>

                  {/* Submenu */}
                  {item.submenu && (
                    <Collapse
                      in={expandedItems.includes(item.key)}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding sx={{ pl: 1.5 }}>
                        {item.submenu.map((subItem) => (
                          <ListItem
                            key={subItem.key}
                            disablePadding
                            sx={{ mb: 0.5 }}
                          >
                            <ListItemButton
                              onClick={() => handleItemClick(subItem.key)}
                              sx={{
                                borderRadius: 2,
                                mx: 1,
                                py: 0.8,
                                backgroundColor:
                                  activeItem === subItem.key
                                    ? "#10B981"
                                    : "transparent",
                                color:
                                  activeItem === subItem.key
                                    ? "white"
                                    : "#6B7280",
                                "&:hover": {
                                  backgroundColor:
                                    activeItem === subItem.key
                                      ? "#059669"
                                      : alpha("#10B981", 0.1),
                                },
                              }}
                            >
                              <ListItemText
                                primary={subItem.text}
                                primaryTypographyProps={{
                                  fontSize: "0.75rem",
                                  fontWeight:
                                    activeItem === subItem.key ? 600 : 500,
                                  pl: 1.5,
                                }}
                              />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </Box>
              ))}
            </List>
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", backgroundColor: "#F9FAFB" }}>
      <CssBaseline />

      {/* AppBar */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: {
            xs: "100%",
            md: desktopOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
          },
          ml: {
            xs: 0,
            md: desktopOpen ? `${drawerWidth}px` : 0,
          },
          backgroundColor: "white",
          borderBottom: "1px solid #E5E7EB",
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Toolbar
          sx={{ justifyContent: "space-between", minHeight: "56px !important" }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {/* Mobile Menu Button */}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 1,
                color: "#374151",
              }}
            >
              <MenuIcon />
            </IconButton>

            {/* Team Selector - Hidden on mobile */}
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 1,
              }}
            >
              {/*
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: "#6366F1",
                  borderRadius: "3px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  color="white"
                  fontWeight="bold"
                  sx={{ fontSize: "0.7rem" }}
                >
                  T
                </Typography>
              </Box>
              <Typography
                variant="body2"
                fontWeight="600"
                color="#374151"
                sx={{ fontSize: "0.8rem" }}
              >
                Team 1
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#F3F4F6",
                  px: 0.8,
                  py: 0.2,
                  borderRadius: 1,
                  fontSize: "0.7rem",
                  color: "#6B7280",
                }}
              >
                Free
              </Box>
              <ExpandMore sx={{ fontSize: 14 }} />*/}
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 1, sm: 1.5 },
            }}
          >
            {/* Search - Responsive width */}
            {/*<Box
              sx={{
                position: "relative",
                backgroundColor: "#F3F4F6",
                borderRadius: 2,
                width: { xs: 100, sm: 180 },
                height: 32,
                display: { xs: "none", sm: "block" },
              }}
            >
              <Search
                sx={{
                  position: "absolute",
                  left: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#9CA3AF",
                  fontSize: 16,
                }}
              />
              <InputBase
                placeholder="⌘K"
                sx={{
                  width: "100%",
                  height: "100%",
                  pl: 4,
                  pr: 1.5,
                  fontSize: "0.8rem",
                  color: "#374151",
                }}
              />
            </Box>*/}

            {/* Search Icon for mobile 
            <IconButton
              sx={{
                color: "#6B7280",
                display: { xs: "flex", sm: "none" },
                p: 0.8,
              }}
            >
              <Search sx={{ fontSize: 18 }} />
            </IconButton>*/}

            {/* Language - Hidden on small mobile 
            <IconButton
              sx={{
                color: "#6B7280",
                display: { xs: "none", sm: "flex" },
                p: 0.8,
              }}
            >
              <Language sx={{ fontSize: 18 }} />
            </IconButton>*/}

            {/* Notifications 
            <IconButton sx={{ color: "#6B7280", p: 0.8 }}>
              <Badge
                badgeContent={4}
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "#EF4444",
                    color: "white",
                    fontSize: "0.7rem",
                    minWidth: 16,
                    height: 16,
                  },
                }}
              >
                <Notifications sx={{ fontSize: 18 }} />
              </Badge>
            </IconButton>*/}

            {/* Settings - Hidden on small mobile 
            <IconButton
              sx={{
                color: "#6B7280",
                display: { xs: "none", sm: "flex" },
                p: 0.8,
              }}
            >
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  border: "2px solid #D1D5DB",
                  borderRadius: "50%",
                }}
              />
            </IconButton>*/}

            {/* Avatar */}
            <IconButton onClick={handleUserMenuClick} sx={{ p: 0 }}>
              <Avatar
                sx={{ width: 28, height: 28 }}
                src="/placeholder.svg?height=28&width=28"
              />
            </IconButton>

            {/* User Menu */}
            <Menu
              anchorEl={anchorEl}
              open={openUserMenu}
              onClose={handleUserMenuClose}
              onClick={handleUserMenuClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  minWidth: 200,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={handleUserMenuClose}>
                <Avatar sx={{ width: 24, height: 24, mr: 1 }} />
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    {authState?.user?.nombre_completo || authState?.user?.nombre}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {authState?.user?.rol?.nombre || "Usuario"}
                  </Typography>
                </Box>
              </MenuItem>
              <Divider />
              {/*<MenuItem onClick={handleUserMenuClose}>
                <ListItemIcon>
                  <Person fontSize="small" />
                </ListItemIcon>
                Perfil
              </MenuItem>
              <MenuItem onClick={handleUserMenuClose}>
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Configuración
              </MenuItem>
              <Divider />*/}
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Cerrar Sesión
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Box
        component="nav"
        sx={{
          width: { md: desktopOpen ? drawerWidth : 0 },
          flexShrink: { md: 0 },
        }}
      >
        {/* Mobile drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              border: "none",
            },
          }}
        >
          {drawer}
        </Drawer>

        {/* Desktop drawer */}
        <Drawer
          variant="persistent"
          open={desktopOpen}
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              border: "none",
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1.5, sm: 2 }, // Reducido aún más
          width: {
            xs: "100%",
            md: desktopOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
          },
          ml: {
            xs: 0,
            md: desktopOpen ? 0 : 0, // Asegurar que no hay margin left cuando está cerrado
          },
          backgroundColor: "#F9FAFB",
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Toolbar sx={{ minHeight: "56px !important" }} />
        {renderContent()}
      </Box>
    </Box>
  );
}
